import { render, staticRenderFns } from "./MandateRepresentant.vue?vue&type=template&id=0894c3c2&"
import script from "./MandateRepresentant.vue?vue&type=script&lang=js&"
export * from "./MandateRepresentant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports